<template>
  <SideMenu
    ref="sideMenu"
    :heading="activeTitle"
    :side="isMobile ? 'right' : 'left'"
    :active-secondary-button="childrenActive"
    @on-secondary-click="unsetChildren"
    @on-side-menu-close="$emit('onFlyoutMenuClose')"
  >
    <div class="p-24">
      <div
        v-for="(flyoutLink, idx) in activeLinks"
        :key="
          flyoutLink.title
            ? 'flyoutLink-' + flyoutLink.title
            : 'flyoutLink' + flyoutLink.type + idx
        "
        :class="{
          'h-32 flex w-full items-center mt-16 first:mt-0':
            flyoutLink.type === 'link',
          'mt-24':
            flyoutLink.type === 'divider' ||
            (activeLinks[idx - 1] && activeLinks[idx - 1].type === 'divider'),
        }"
      >
        <div
          v-if="flyoutLink.type === 'link'"
          class="w-full select-none cursor-pointer"
        >
          <div
            v-if="flyoutLink.children && flyoutLink.children.length > 0"
            @click="setChildren(flyoutLink.children, flyoutLink.title)"
          >
            <div class="flex flex-1 justify-between">
              <div class="flex items-center text-grey">
                <img
                  v-if="flyoutLink.icon"
                  :src="flyoutLink.icon"
                  class="rounded-full h-32 w-32 mr-12"
                >
                {{ flyoutLink.title }}
              </div>
              <img src="~/assets/icons/arrow-right.png" class="h-20 w-20">
            </div>
          </div>
          <a v-else-if="flyoutLink.external" :href="flyoutLink.url">
            <div class="flex flex-1 justify-between">
              <div class="flex items-center text-grey">
                <img
                  v-if="flyoutLink.icon"
                  :src="flyoutLink.icon"
                  class="rounded-full h-32 w-32 mr-12"
                >
                {{ flyoutLink.title }}
              </div>
            </div>
          </a>
          <nuxt-link
            v-else
            :to="flyoutLink.url || '/'"
            @click.native="$emit('onFlyoutMenuClose')"
          >
            <div class="flex flex-1 justify-between">
              <div class="flex items-center text-grey">
                <img
                  v-if="flyoutLink.icon"
                  :src="flyoutLink.icon"
                  class="rounded-full h-32 w-32 mr-12"
                >
                {{ flyoutLink.title }}
              </div>
            </div>
          </nuxt-link>
        </div>
        <div v-else-if="flyoutLink.type === 'divider'" class="border-b border-b-black-25" />
      </div>
    </div>
  </SideMenu>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import type { PropType } from 'vue';
import { type NavigationType } from '~/constants/types/navigation';
import SideMenu, { type SideMenuInterface } from '~/components/navigation/SideMenu.vue';

export default defineComponent({
  components: {
    SideMenu,
  },
  props: {
    links: {
      type: Array as PropType<NavigationType[]>,
      required: true,
    },
    isMobile: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['onFlyoutMenuClose'],
  data() {
    return {
      activeLinks: this.links,
      activeTitle: this.$lang('header', 'menu'),
      childrenActive: false,
    };
  },
  mounted() {
    this.toggleSideMenu();
  },
  methods: {
    toggleSideMenu() {
      const sideMenu = this.$refs.sideMenu as SideMenuInterface;
      sideMenu.openOverlay();
    },
    setChildren(links: NavigationType[], title: string) {
      this.activeLinks = links;
      this.activeTitle = title;
      this.childrenActive = true;
    },
    unsetChildren() {
      this.activeLinks = this.links;
      this.activeTitle = this.$lang('header', 'menu');
      this.childrenActive = false;
    },
  },
});
</script>
